'use client';

import { useState, useEffect } from 'react';

import { SearchBar } from '@/elements/search-bar/search-bar.component';
import { PostCard } from '@/elements/post-card/post-card.component';
import { CardsGrid } from '@/elements/cards-grid/cards-grid.component';
import { Container } from './posts.elements';

import { getPostsByTag } from '@/actions/get-posts-by-tag.action';
import { filterPosts } from '@/helpers/post-filters.helpers';

const Posts = ({ posts: allPosts, tags, type }) => {
  const [posts, setPosts] = useState(allPosts);
  const [activeTag, setActiveTag] = useState(null);
  const [search, setSearch] = useState('');
  const [filters, setFilters] = useState([]);

  /*
   * Updated logic:
   * handleTagClick only sets the active tag.
   * useEffect handles data fetching whenever activeTag or filters change.
   */
  const handleTagClick = (tag) => {
    setActiveTag(tag);
  };

  const handleFilterPosts = async ({ filters }) => {
    // Get base posts - if we have an active tag, get those posts, otherwise use all posts
    let basePosts = allPosts;

    if (activeTag) {
      basePosts = await getPostsByTag({ type, tag: activeTag });
    }

    // Apply filters client-side
    const filteredPosts = filterPosts(basePosts, filters);
    setPosts(filteredPosts);
  };

  useEffect(() => {
    handleFilterPosts({ filters });
  }, [filters, activeTag]);

  return (
    <Container>
      <SearchBar
        setPosts={setPosts}
        search={search}
        setSearch={setSearch}
        filters={filters}
        setFilters={setFilters}
        tags={tags}
        onTagClick={handleTagClick}
        activeTag={activeTag}
        target="posts"
      />
      <CardsGrid data={posts} Card={PostCard} withSearch filters={filters} type="post" />
    </Container>
  );
};

export { Posts };
